import { makeInternalAPIRequest } from 'lib/http/ApiProvider'
import Response from 'lib/http/Response'

export const getReports = (): Promise<Response> =>
	makeInternalAPIRequest('get', '/reports')
